import { render, staticRenderFns } from "./ColumnActiveIcon.vue?vue&type=template&id=65983f42&scoped=true"
import script from "./ColumnActiveIcon.vue?vue&type=script&lang=ts"
export * from "./ColumnActiveIcon.vue?vue&type=script&lang=ts"
import style0 from "./ColumnActiveIcon.vue?vue&type=style&index=0&id=65983f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65983f42",
  null
  
)

export default component.exports